// lightgallery.js with plugins
import lightGallery from 'lightgallery';
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgZoom from 'lightgallery/plugins/zoom';
import lgFullscreen from 'lightgallery/plugins/fullscreen';
import lgAutoplay from 'lightgallery/plugins/autoplay';

// Needs to be set if website is in production / live mode!!
const LB_LICENSE = 'E7C284EC-D3AC420C-B35E011F-380C82F8';

export let __trigger_lightbox = async function () {
    let media_gallery_trigger = '.media--block.js--media-gallery';
    $(media_gallery_trigger).on('click', async function () {
        let widget = $(this).attr('data-widget');
        let gallery_id = $(this).attr('gallery-id');
        let rand_id = $(this).attr('data-rand-id');
        $(
            '.stmnt--lightbox.gallery[data-widget="' +
                widget +
                '"][data-rand-id="' +
                rand_id +
                '"][data-gallery="' +
                gallery_id +
                '"]'
        ).trigger('click');
    });

    let single_lightbox_trigger =
        '.media--block:not(.js--media-gallery):not(.social):not(.is-video):not(.opens--modal), .illustration--loop';
    $(single_lightbox_trigger).on('click', async function () {
        let widget = $(this).attr('data-widget');
        let rand_id = $(this).attr('data-rand-id');


        const $el = $('.stmnt--lightbox.single[data-widget="' + widget + '"][data-rand-id="' + rand_id + '"]')
        console.log($el)
        $el.trigger('click');
    });
};

export let __init_single_lightboxes = function () {
    let lightboxes = document.querySelectorAll('.stmnt--lightbox.single');
    if (lightboxes.length > 0) {
        for (let lightbox of lightboxes) {
            let gallery = lightbox.getAttribute('data-gallery');
            if (gallery == 'false') {
                const singleLightbox = lightGallery(lightbox, {
                    plugins: [lgZoom, lgFullscreen],
                    licenseKey: LB_LICENSE,
                    speed: 500,
                    autoplay: false,
                    thumbnail: false,
                    animateThumb: false,
                    subHtmlSelectorRelative: true,
                    zoomFromOrigin: true,
                    allowMediaOverlap: true,
                    download: false,
                    showCloseIcon: true,
                    toggleThumb: false,
                    addClass: 'stmnt--lg-lightbox single',
                    fullScreen: true,
                    mobileSettings: {},
                });

                lightbox.addEventListener('click', function () {
                    // Starts with third item.(Optional).
                    // This is useful if you want use dynamic mode with
                    // custom thumbnails (thumbnails outside gallery),
                    singleLightbox.openGallery(0);
                });
            }
        }
    }
};

export let __init_lightboxes = function () {
    let lightboxes = document.querySelectorAll('.stmnt--lightbox.gallery');

    if (lightboxes.length > 0) {
        for (let lightbox of lightboxes) {
            const dynamicGallery = lightGallery(lightbox, {
                plugins: [lgZoom, lgThumbnail, lgFullscreen, lgAutoplay],
                licenseKey: LB_LICENSE,
                speed: 500,
                autoplay: true,
                thumbnail: true,
                animateThumb: false,
                zoomFromOrigin: true,
                allowMediaOverlap: true,
                subHtmlSelectorRelative: true,
                download: false,
                showCloseIcon: true,
                toggleThumb: true,
                addClass: 'stmnt--lg-lightbox gallery',
                fullScreen: true,
                mobileSettings: {},
            });

            lightbox.addEventListener('click', function () {
                // Starts with third item.(Optional).
                // This is useful if you want use dynamic mode with
                // custom thumbnails (thumbnails outside gallery),
                dynamicGallery.openGallery(0);
            });

            lightbox.addEventListener('lgBeforeSlide', (event) => {
                $('.lg-autoplay-button').removeClass('active');
                if (event.detail.fromTouch) {
                    $('.lg-toggle-thumb').addClass('active');
                }
            });
        }
    }
};
